import {
  SizeGuideSection 
} from "../size-guide-section"

// src/components/size-guide-new/kids/wader.tsx
const kidsWaderTableData = {
  headers: [
    [
      {
        content: "Neoprene Waders",
        colSpan: 6
      }
    ],
    [
      {
        content: "Wader Size"
      },
      {
        content: "Shoes Size"
      },
      {
        content: "Total Length(In)"
      },
      {
        content: "Inseam(In)"
      },
      {
        content: "Chest(In)"
      },
      {
        content: "Hip(In)"
      }
    ]
  ],
  data: [
    [
      {
        content: "2T" 
      },
      {
        content: "6T" 
      },
      {
        content: "26.8" 
      },
      {
        content: "14.2" 
      },
      {
        content: "25.2" 
      },
      {
        content: "25.2" 
      }
    ],
    [
      {
        content: "3T" 
      },
      {
        content: "9T" 
      },
      {
        content: "24.3" 
      },
      {
        content: "15.7" 
      },
      {
        content: "26" 
      },
      {
        content: "26" 
      }
    ],
    [
      {
        content: "4/5T" 
      },
      {
        content: "12" 
      },
      {
        content: "31.9" 
      },
      {
        content: "20.9" 
      },
      {
        content: "31.5" 
      },
      {
        content: "30.5" 
      }
    ],
    [
      {
        content: "6/7T" 
      },
      {
        content: "2" 
      },
      {
        content: "37.4" 
      },
      {
        content: "23.2" 
      },
      {
        content: "32.6" 
      },
      {
        content: "31.5" 
      }
    ],
    [
      {
        content: "8/9T" 
      },
      {
        content: "4" 
      },
      {
        content: "40.2" 
      },
      {
        content: "24.8" 
      },
      {
        content: "34.6" 
      },
      {
        content: "33.5" 
      }
    ],
    [
      {
        content: "10/11T" 
      },
      {
        content: "6" 
      },
      {
        content: "44.1" 
      },
      {
        content: "26.8" 
      },
      {
        content: "36.2" 
      },
      {
        content: "35" 
      }
    ],
    [
      {
        content: "12/13T" 
      },
      {
        content: "8" 
      },
      {
        content: "48" 
      },
      {
        content: "29.1" 
      },
      {
        content: "37.8" 
      },
      {
        content: "36" 
      }
    ]
  ]
}

export const KidsWader = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Neoprene Waders'
    tableData={kidsWaderTableData}
    className={className}
  />
}
